import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/app.constant';
import { DataToDelete, EditIdNameModel } from 'src/app/_metronic/core/classes/core.class';
import { AttendanceReportClasses } from '../attendance.classes';
import { ToasterService, ToasterType } from 'src/app/services/toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  apiUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant,private toasterService: ToasterService) {
    this.apiUrl = this.appConstant.getUrl();
  }

  public downloadExcelAttendance(dateRange) {
    return this.httpClient.post(`${this.apiUrl}/downloadExcelAttendance`, dateRange,{ responseType: 'blob' })
  }

  insertAttendance(attendance) {
    return this.httpClient.post(`${this.apiUrl}/insertAttendance`, attendance).pipe(
      map((response: any) => {
        return response;
      }))
  }
  manageAttendance(attendance) {
    return this.httpClient.post(`${this.apiUrl}/manageAttendance`, attendance).pipe(
      map((response: any) => {
        return response;
      }))
  }
  updateAttendance(attendance) {
    return this.httpClient.post(`${this.apiUrl}/attandanceUpdate`, attendance).pipe(
      map((response: any) => {
        return response;
      }))
  }
  getUsersForAttendance(attandanceData) {
    return this.httpClient.post(`${this.apiUrl}/getUsersForAttendance/`, attandanceData).pipe(
      map((response: any) => {
        return response.data
      })
    )
  }
  getAttendanceById(Id: number) {
    return this.httpClient.get(`${this.apiUrl}/getAttendanceById/` + Id).pipe(
      map((response: any) => {
        return response.data
      })
    )
  }
  getTimingSlotsForAttendance(attandanceData): Observable<GridDataResult> {
    return this.httpClient.post(`${this.apiUrl}/getTimingSlotsForAttendance/`, attandanceData).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  public getAllAttendanceKendo(filters): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllAttendance/`, filters).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  public getAllAttendanceDetailData(data: AttendanceReportClasses, id: number): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getWeeklyAttendanceReport/`, data).pipe(
      map((response: any) => {
        return {
          data: response.data[id].AttendanceData,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  // public getWeeklyAttendanceReport(data: AttendanceReportClasses): Observable<DataResult> {
  //   return this.httpClient.post(`${this.apiUrl}/getWeeklyAttendanceReport/`, data).pipe(
  //     map((response: any) => {
  //       return {
  //         data: response.data,
  //         total: response.total
  //       } as GridDataResult
  //     })
  //   ) as any as Observable<GridDataResult>
  // }
  getWeeklyAttendanceReportExcel(data: AttendanceReportClasses) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/getWeeklyAttendanceReport/`, data).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  // --------------------------------------------------------------------------------------------------------------------------------











  getAttendanceListByClassIdAndSectionId(attandanceData): Observable<GridDataResult> {
    return this.httpClient.post(`${this.apiUrl}/attendanceListKendo/`, attandanceData).pipe(
      map((response: any) => {
        var data = response.data
        return {
          data: data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  getAttendanceRegister(attandanceData): Observable<GridDataResult> {
    return this.httpClient.post(`${this.apiUrl}/attendanceRegister/`, attandanceData).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  getAllAttendanceListExcel(state: DataSourceRequestState) {
    let params = {
      state: state
    }
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/getAllAttendance/`, params).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  public getAllStudentKendo(branchId: number, state: DataSourceRequestState): Observable<DataResult> {
    let params = {
      branchId: branchId,
      state: state
    }
    return this.httpClient.post(`${this.apiUrl}/studentListKendo/`, params).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  public getAllBeaconData(branchId: number, state: DataSourceRequestState): Observable<DataResult> {
    let params = {
      branchId: branchId,
      state: state
    }
    return this.httpClient.post(`${this.apiUrl}/beaconListKendo/`, params).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  getAllForAttendanceModel(branchId: number, classId: number, sectionId: number) {
    let params = {
      classId: classId,
      sectionId: sectionId,
    }
    return this.httpClient.post(`${this.apiUrl}/getStudentsForAttendance/`, params).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  deleteMultipleAttendance(AttendanceIdNameList: Array<DataToDelete> = []) {
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteAttendance/`, {
      DataToDelete: AttendanceIdNameList
    }).pipe(
      map((response: any) => {
        return response;
      }))
  }

  public downloadImageAttendanceWeeklyReport(data) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/downloadImageAttendanceWeeklyReport`, data, { responseType: 'blob' }).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status == 403) {
            this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
          }
          reject(err);
        });
    });
  }
  public downloadExcelAttendanceWeeklyReport(data) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/downloadExcelAttendanceWeeklyReport`, data, { responseType: 'blob' }).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status == 403) {
            this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
          }
          reject(err);
        });
    });
  }

  public getAllAttendanceStatus() {
    return this.httpClient.get(`${this.apiUrl}/getAllAttendanceStatus/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }
  getAttendanceStatusById(Id) {
    return this.httpClient.get(`${this.apiUrl}/getAttendanceStatusById/` + Id).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  manageAttendanceStatus(manegeStatus) {
    return this.httpClient.post(`${this.apiUrl}/manageAttendanceStatus`, manegeStatus).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  bulkDeleteAttendanceStatus(examTypeIdNameList: Array<EditIdNameModel> = []) {
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteAttendanceStatus/`, {
      DataToDelete: examTypeIdNameList
    }).pipe(
      map((response: any) => {
        return response;
      }))
  }

  createDefualtStatus() {
    return this.httpClient.post(`${this.apiUrl}/createDefualtAttendanceStatus`, null).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  GetAttendanceConfig() {
    return this.httpClient.get(`${this.apiUrl}/getAttendanceConfig`).pipe(
        map((response: any) => {
            return response;
        })
    );
  }
  // async GetAttendanceConfig(): Promise<any> {
  //   return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAttendanceConfig`).toPromise()).data;
  // }

  ManageAttendanceConfig(data) {
    return this.httpClient.post(`${this.apiUrl}/manageAttendanceConfig`, data).pipe(
        map((response: any) => {
            return response;
        })
    );
  }
  
}